import { z } from 'zod';

import { Address } from '../Address';
import { CompanyWireSettingsId, LoanOwnerId } from '../BrandedIds';

export const CompanyWireSettings = z.object({
  id: CompanyWireSettingsId,
  isDefault: z.boolean(),
  bankName: z.string(),
  bankRoutingNumber: z.string(),
  accountName: z.string(),
  accountNumber: z.string(),
  bankAddress: Address,
  instructions: z.string().optional(),
  ownerIds: z.array(LoanOwnerId),
});
export type CompanyWireSettings = z.infer<typeof CompanyWireSettings>;
